<script lang="ts">
  import Modal from '../Modal.svelte';
  import Text from '../Text.svelte';
  import Button from '../Button.svelte';
  import { Redirect } from '../../utils/redirect.service.js';
  import { addToast } from '../toast/store.js';
  import { getUserErrorMessage } from 'src/utils/error.js';

  type ResponseObject = {
    data: Redirect[];
  };

  export let isOpen: boolean;
  export let getAllRedirects: () => Promise<ResponseObject>;
  const columnNames =
    'Quelle; Ziel; Typ; Tag; Startdatum; Ablaufdatum; Erstellungsdatum; Letzte Aenderung';

  const downloadRedirectList = async () => {
    try {
      const response = await getAllRedirects();
      const formattedRedirects = response.data
        .map(
          (redirect: Redirect) =>
            `${redirect.source};${redirect.destination};${redirect.redirect_type};${redirect.tag || ''};${redirect.start_date || ''};${redirect.expiration_date || ''};${redirect.created_at};${redirect.updated_at}`
        )
        .join('\n');

      const csvContent = [columnNames, formattedRedirects].join('\n');
      const encodedUri = encodeURIComponent(csvContent);
      const csvLink = 'data:text/csv;charset=utf-8,' + encodedUri;
      const fragment = document.createDocumentFragment();
      const downloadLink = document.createElement('a');
      downloadLink.setAttribute('href', csvLink);
      downloadLink.setAttribute('download', 'alle-redirects.csv');
      fragment.appendChild(downloadLink);
      downloadLink.click();
    } catch (e) {
      addToast({
        type: 'error',
        message: getUserErrorMessage(e, 'Fehler beim Herunterladen der Weiterleitungen')
      });
    } finally {
      isOpen = false;
    }
  };
</script>

<Modal size="small" label="Weiterleitungen exportieren" bind:isOpen>
  <Text size="medium">Möchten Sie eine CSV-Datei mit allen Redirects herunterladen?</Text>

  <svelte:fragment slot="button">
    <Button on:click={() => (isOpen = false)}>Abbrechen</Button>
    <Button on:click={downloadRedirectList} variant="primary">Herunterladen</Button>
  </svelte:fragment>
</Modal>
